import React, { Component } from 'react';
import './css/adminlogin.css';

class AdminLogin extends Component {
	constructor(props){
		super(props);
		//console.log("AdminLogin()");
		this.state = { 
			loginState : "", 
			scheduledMessageState: "",
			ajaxLoadingState:""
		};
	}
	componentDidMount() {
	}

	componentWillUnmount() {
	}

	unscheduledOutage(){
		document.getElementById("unscheduled-message").innerHTML = window.l10n[window.locale]["login.unscheduled.message"];
		this.setState({loginState: "unscheduled"});
	}	

	doLogin(evt){
	}

	render() {
		var t = this;
		return (
		<div id="adminlogin-container" className={this.state.loginState + " " + this.state.scheduledMessageState}>
			<div className={"ajax-spinner-lightbox " + this.state.ajaxLoadingState } />
			<div className="innerContainer">
				<div className="login-caption">
					{ window.l10n[window.locale]["login.logintoyouraccount"] }
				</div>

				<input type="text" className="login-inp login-inp1" id="id-username" placeholder={ window.l10n[window.locale]["adminlogin.username"] } />
				<input type="password" className="login-inp login-inp2" id="id-password" placeholder={ window.l10n[window.locale]["adminlogin.password"] } />

				<button type="button" className="login-btn" id="id-btn-sign-in" onClick={
					(e)=>{
						//console.log("Admin Logging in...");

						var un=document.getElementById("id-username").value.trim();
						var pw=document.getElementById("id-password").value.trim();
						if ("" === un || "" === pw) return;

						var xhr = new XMLHttpRequest();
						xhr.onreadystatechange = function() {
							if (this.readyState === 4){
								if (this.status === 200) {
									//console.log("responseText: " + this.responseText);
									var responseJson = "";
									if (this.responseText) responseJson = JSON.parse(this.responseText);
									//console.log("JSON: %o", responseJson);
									//console.log("hdr X-OPTA-AUTH:" + this.getResponseHeader("X-OPTA-AUTH"));
									if (this.getResponseHeader("X-OPTA-AUTH")){
										var optaToken = responseJson["OPTATOKEN"];

										//console.log("AuthToken:" + optaToken);
										t.setState({loginState: "", ajaxLoadingState: ""});
										window.location.href = "admin-" + window.locale + "?oa=" + optaToken;
									} else {
										t.setState({ajaxLoadingState: ""});
										t.props.ctx.doLogout();
									}
								} else {
									//console.log("invalid credentials");
									window.optatoken = "";
									t.setState({loginState: "failed-login", ajaxLoadingState: ""});
									t.props.ctx.doLogout();
								}
							}
						};

						xhr.open('post', window.AppConfig["url-authenticate"], true);
						xhr.setRequestHeader('Content-Type', 'application/json; charset=utf-8');
						this.setState({ajaxLoadingState: "loading"});
						xhr.send( JSON.stringify({
							vin : btoa(un),
							acct: btoa(pw),
							isLessee : false,
							isAcctAdmin : true						
						}));
					}
				}>{ window.l10n[window.locale]["login.signin"] }</button>

				<div className="login-text">
					{ window.l10n[window.locale]["login.caption1"] }
				</div>
				<div className="login-failed-container">
					<div className="exclam"></div>
					<div className="l1">{ window.l10n[window.locale]["login.fail.line1"] }</div>
				</div>
				<div className="login-unscheduled-container" >
					<div className="exclam"></div>
					<div id="unscheduled-message" className="l1" ></div>
				</div>
			</div>
		</div>
		);
	}
}

export default AdminLogin;



// WEBPACK FOOTER //
// ./src/components/adminlogin.js